<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g transform="translate(-8.166 -9.315)">
      <rect class="a" width="6" height="2" rx="1" transform="translate(10.166 16.315)"/>
      <rect class="a" width="6" height="2" rx="1" transform="translate(17.166 16.315)"/>
      <rect class="a" width="10" height="2" rx="1" transform="translate(15.166 9.315)"/>
      <rect class="a" width="24" height="2" rx="1" transform="translate(8.166 12.315)"/>
      <rect class="a" width="24" height="2" rx="1" transform="translate(8.166 31.315)"/>
      <rect class="a" width="11" height="2" rx="1" transform="translate(21.166 19.315) rotate(90)"/>
      <rect class="a" width="11" height="2" rx="1" transform="translate(14.166 19.315) rotate(90)"/>
      <rect class="a" width="11" height="2" rx="1" transform="translate(28.166 19.315) rotate(90)"/>
      <rect class="a" width="6" height="2" rx="1" transform="translate(24.166 16.315)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "MarketplaceIcon"
}
</script>

<style scoped>
.a {
  fill: #fff;
}
</style>
